"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdentityModel = void 0;
var collections_1 = require("../utils/collections");
var uuidv4 = require('uuid').v4;
var IdentityModel = /** @class */ (function () {
    function IdentityModel(created_date, identityTraits, identityFeatures, environmentApiKey, identifier, identityUuid, djangoID) {
        this.identityUuid = identityUuid || uuidv4();
        this.createdDate = Date.parse(created_date) || Date.now();
        this.identityTraits = identityTraits;
        this.identityFeatures = new (collections_1.IdentityFeaturesList.bind.apply(collections_1.IdentityFeaturesList, __spreadArray([void 0], __read(identityFeatures), false)))();
        this.environmentApiKey = environmentApiKey;
        this.identifier = identifier;
        this.djangoID = djangoID;
    }
    Object.defineProperty(IdentityModel.prototype, "compositeKey", {
        get: function () {
            return IdentityModel.generateCompositeKey(this.environmentApiKey, this.identifier);
        },
        enumerable: false,
        configurable: true
    });
    IdentityModel.generateCompositeKey = function (env_key, identifier) {
        return "".concat(env_key, "_").concat(identifier);
    };
    IdentityModel.prototype.updateTraits = function (traits) {
        var e_1, _a, e_2, _b, e_3, _c;
        var existingTraits = new Map();
        try {
            for (var _d = __values(this.identityTraits), _e = _d.next(); !_e.done; _e = _d.next()) {
                var trait = _e.value;
                existingTraits.set(trait.traitKey, trait);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
            }
            finally { if (e_1) throw e_1.error; }
        }
        try {
            for (var traits_1 = __values(traits), traits_1_1 = traits_1.next(); !traits_1_1.done; traits_1_1 = traits_1.next()) {
                var trait = traits_1_1.value;
                if (!!trait.traitValue) {
                    existingTraits.set(trait.traitKey, trait);
                }
                else {
                    existingTraits.delete(trait.traitKey);
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (traits_1_1 && !traits_1_1.done && (_b = traits_1.return)) _b.call(traits_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        this.identityTraits = [];
        try {
            for (var _f = __values(existingTraits.entries()), _g = _f.next(); !_g.done; _g = _f.next()) {
                var _h = __read(_g.value, 2), k = _h[0], v = _h[1];
                this.identityTraits.push(v);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_g && !_g.done && (_c = _f.return)) _c.call(_f);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    return IdentityModel;
}());
exports.IdentityModel = IdentityModel;
